import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as S from './styles';

export const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <S.Container $scrolled={scrolled} id="navbar">
      <S.Logo as={Link} to="/">
        <img src="/assets/logo.svg" alt="Excursei" />
      </S.Logo>
      <S.NavLinks>
        <S.NavLink href="#sobre" onClick={(e) => handleClick(e, '#sobre')}>
          Sobre
        </S.NavLink>
        <S.NavLink href="#recursos" onClick={(e) => handleClick(e, '#recursos')}>
          Recursos
        </S.NavLink>
        <S.NavLink
          href="#como-funciona"
          onClick={(e) => handleClick(e, '#como-funciona')}
        >
          Como Funciona
        </S.NavLink>
        <S.DownloadButton
          href="#download"
          className="btn-nav"
          onClick={(e) => handleClick(e, '#download')}
        >
          Baixar App
        </S.DownloadButton>
      </S.NavLinks>
    </S.Container>
  );
};
